import * as actions from 'app/actions/geofence';
import http from 'app/services/http';

export const geofenceReducer = (
    state = {
        typeItems: [],
        groupItems: [],
        groupSearchValue: '',
        groupSelectedItem: null,
    },
    action
) => {
    switch (action.type) {
        case 'GEOFENCE_GROUP_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                groupItems: items,
            };
        }
        case 'GEOFENCE_GROUP_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupSelectedItem: data,
            };
        }
        case 'GEOFENCE_GROUP_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                groupSearchValue: value,
            };
        }
        case 'GEOFENCE_GROUP_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupItems: [...state.groupItems, data],
            };
        }
        case 'GEOFENCE_GROUP_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupSelectedItem: data,
                groupItems: state.groupItems.map((value) => {
                    if (value.id !== state.groupSelectedItem.id) {
                        return value;
                    }

                    return data;
                }),
            };
        }
        case 'GEOFENCE_GROUP_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                groupItems: state.groupItems.filter((item) => item.id !== id),
                groupSelectedItem: null,
            };
        }
        case 'GEOFENCE_SET_TYPE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                typeItems: items,
            };
        }
        default:
            return state;
    }
};

export function geofenceGroupLoad() {
    return async function geofenceGroupLoadThunk(dispatch) {
        const { data } = await http.get(`/geofence/group`);
        return dispatch(actions.setGroupItems(data));
    };
}

export function geofenceGroupCreate(params) {
    return async function geofenceCreateThunk(dispatch) {
        const { data } = await http.post('/geofence/group', params);
        return dispatch(actions.addGroupItem(data));
    };
}

export function geofenceGroupUpdate(id, params) {
    return async function geofenceUpdateThunk(dispatch) {
        const { data } = await http.put(`/geofence/group/${id}`, params);
        return dispatch(actions.updateGroupItem(data));
    };
}

export function geofenceGroupDelete(id) {
    return async function geofenceDeleteThunk(dispatch) {
        await http.delete(`/geofence/group/${id}`);
        return dispatch(actions.deleteGroupItem(id));
    };
}

export async function geofenceGroupFormLoad() {
    return http
        .get('/geofence/group')
        .then((response) => response.data)
        .then((response) => {
            return response;
        })
        .catch();
}

export function geofenceTypeLoad() {
    return async function geofenceTypeLoadThunk(dispatch) {
        const { data } = await http.get('/geofence/type');
        return dispatch(actions.setTypeItems(data));
    };
}

export default geofenceReducer;
